import { render, staticRenderFns } from "./CoachCentralScoutingDashboard.vue?vue&type=template&id=32df3792&scoped=true&"
import script from "./CoachCentralScoutingDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoachCentralScoutingDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CoachCentralScoutingDashboard.vue?vue&type=style&index=0&id=32df3792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df3792",
  null
  
)

export default component.exports